export const downloadFile = (content: BlobPart, filename: string, mimeType: string = 'text/plain'): void => {
  const file = new Blob([content], { type: mimeType });
  const tempLink = document.createElement('a');
  tempLink.href = window.URL.createObjectURL(file);
  tempLink.setAttribute('download', filename);
  document.body.appendChild(tempLink); // Append to body to ensure compatibility in Safari
  tempLink.click();
  window.URL.revokeObjectURL(tempLink.href);
  document.body.removeChild(tempLink); // Clean up
};
